import { domainUrl } from '../constants';

export const API_EVENT_PAGE = `${domainUrl}landing-pages`;
export const API_EVENT_PAGE_BY_ID = `${domainUrl}landing-pages/{id}`;
export const API_EVENT_PAGE_BLOCK = `${domainUrl}landing-pages/{id}/blocks`;
export const API_EVENT_PAGE_BLOCK_BY_BLOCK_ID = `${domainUrl}landing-pages/{id}/blocks/{block_id}`;
